import { sessionSelector } from 'app/store/session/selectors';
import { toastError, toastSuccess } from 'modules/utils';
import { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useOnlineDetection } from 'shared/hooks';
import { toast } from 'react-toastify';

export const OnlineDetectionNotifier: FC = () => {
  const currentUser = useSelector(sessionSelector.activeUser);
  const isAuthorized = currentUser.userId;

  const offlineToast = useRef<React.ReactText | undefined>();
  const onlineToast = useRef<React.ReactText | undefined>();

  useOnlineDetection({
    onReconnected: () => {
      if (!isAuthorized) return;

      if (offlineToast.current) {
        toast.dismiss(offlineToast.current);
      }

      if (!onlineToast.current) {
        onlineToast.current = toastSuccess('You are back online.', {
          onClose: () => {
            onlineToast.current = undefined;
          },
        });
      }
    },
    onDisconnected: () => {
      if (!isAuthorized) return;

      if (onlineToast.current) {
        toast.dismiss(onlineToast.current);
      }

      offlineToast.current = toastError('You are offline, some functions may not work properly.', {
        autoClose: false,
      });
    },
  });

  return null;
};
